import { Backdrop, CircularProgress } from '@mui/material';
import { FC } from 'react';

interface Props {
  open: boolean;
}

const FullScreenLoading: FC<Props> = ({ open }) => {
  return (
    <Backdrop style={{ zIndex: 99999, color: '#fff' }} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default FullScreenLoading;
